import { yupArray } from 'services/yup/custom-schemas/array'
import { yupNumber } from 'services/yup/custom-schemas/number'
import { yupIgnore } from 'services/yup/helpers'
import { KTestConfig, KTestFunction, YupSchema } from 'services/yup/types'
import { standardPricingArrayVS } from './standard-pricing/standardPricingArray'
import { APIPriceRange } from 'services/api/entities/catalog/types'
import { productCommonVS } from './productCommon'
import { DEFAULT_PRICE_RANGE_MAX_QUANTITY } from 'services/cfg/form'
import { UpsellingEntity } from 'services/api/entities'
import { withQuantityHintVS } from './hints'
import { Upselling } from 'services/api/entities/catalog/upselling/types/internal/upselling-models'

/**
 * Requires at least one price range to have maxQuantity set to the default max quantity
 * @param values price ranges
 */
const validateMaxQuantityPricingRange: KTestFunction<APIPriceRange[]> = (
  values
) =>
  !values ||
  values.some((p) => p?.maxQuantity === DEFAULT_PRICE_RANGE_MAX_QUANTITY)

const hasMaxQuantityPriceRangeCFG: KTestConfig<APIPriceRange[]> = {
  test: validateMaxQuantityPricingRange,
  message: `At least one pricing must have Max Quantity set to ${DEFAULT_PRICE_RANGE_MAX_QUANTITY}`,
}

export const upsellingVSBuilder = (
  entity: UpsellingEntity
): YupSchema<Upselling> =>
  productCommonVS.concat(withQuantityHintVS).shape({
    pricing: standardPricingArrayVS.min(1).when({
      is: () => entity === 'virtualupselling',
      then: (schema) => schema.test(hasMaxQuantityPriceRangeCFG),
    }),
    minQuantity: yupNumber().required().min(1),
    pricingFacet: yupIgnore(),
    groupFacet: yupIgnore(),
    products: yupArray(),
    isPerItem: yupIgnore(),
  })
